(ns frontend.ui.page.lp-report-editor.common.modal.edit-text-modal
  (:require
   [common.util :as cu]
   [ui.components.button.view :as button]
   [frontend.ui.component.modal-dialog.view :as modal-dialog]
   [frontend.ui.page.lp-report-editor.common.modal.style :as style]
   [common.localization :as loc]
   [frontend.ui.page.lp-report-editor.common.style :as common-style]
   [frontend.ui.component.label.style :as label-style]
   [frontend.ui.component.text-input.style :as input-style]
   [frontend.ui.component.icon.style :as icon-style]
   [herb.core :as h]
   [potpuri.core :as p]
   [reagent.core :as r]))

(defn view
  [{:keys [on-hide! header submit-txt on-submit! complete-button-disabled? edit-later-button-disabled? on-submit-edit-later! rich-text-editor]} & children]
  (let [local-state (r/atom {})]
    (fn [{:keys [on-hide! header submit-txt on-submit! complete-button-disabled? edit-later-button-disabled? on-submit-edit-later! rich-text-editor]}]
      (let []
        [modal-dialog/modal-dialog
         {:visible?     true
          :hide!        (fn []
                          (on-hide!))
          :header-label (or header
                            (loc/tr :email-notification))
          :size         :sm
          :style        {:body {:min-height "0"
                                :max-height "65vh"
                                :overflow-y "auto"}}}
         [:div
          children]
         [:div
          {:class (h/<class common-style/footer-right)}
          [button/secondary-hollow
           {:on-click on-hide!}
           (loc/tr :cancel)] 
          [:div
           [button/primary-solid
            {:disabled? complete-button-disabled?
             :on-click  (fn [_]
                          (on-submit!))}
            "Save and complete"]]
          [:div
           [button/primary-solid
            {:disabled? edit-later-button-disabled?
             :on-click  (fn [_]
                          (on-submit-edit-later!))}
            "Save and edit later"]]]]))))
